import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'vrmDelimiter',
    standalone: false
})
export class VrmDelimiterPipe implements PipeTransform {
  transform(vrm: string, countryCode: string, delimiter: number) {
    if (vrm === undefined) return '';
    if (delimiter === 0) return countryCode + '-' + vrm;
    if (delimiter !== 0 && vrm.indexOf('-') !== -1)
      return countryCode + '-' + vrm;

    const preDelimiterVrm = vrm.substring(0, delimiter);
    const postDelimiterVrm = vrm.substring(delimiter, vrm.length);
    const result = `${countryCode}-${preDelimiterVrm}-${postDelimiterVrm}`;
    return result;
  }
}
